'use client';

import { generateVerifiableHash } from '@repo/common/utils/hash';
import { useEffect, useState } from 'react';

export const useLocalToken = (): string | null => {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('localToken');
    if (storedToken) {
      setToken(storedToken);
    } else {
      // Generate a new token if one doesn't exist
      const newToken = generateVerifiableHash();
      localStorage.setItem('localToken', newToken);
      setToken(newToken);
    }
  }, []);

  return token;
};
